module.exports = __webpack_public_path__ + "sm_666_oo.f2152a80067a1d6ed821.gif";